var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.$t('duplicate')}},[_c('BaseButton',{staticClass:"btn-link btn-github btn-simple",attrs:{"size":"sm","icon":""},on:{"click":_vm.clone}},[_c('i',{staticClass:"far fa-copy"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }